import { AgpSharedAggregatorOptions } from '@liberty-financial/agp-shared';

import { Claims } from '@core/authentication/claims';

type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};

export enum AggregatorFeatureFlag {
  ProductMatrix = 'Product matrix',
  ManualRefix = 'Manual refix',
  RefixReport = 'Refix report',
  ContactsReport = 'Contacts report',
  OpportunitiesReport = 'Opportunities report',
  CanvasMetricsReport = 'Email campaign metrics report',
  Reports = 'Reports',
  DeleteDiaryNote = 'Delete diary note',
  Events = 'Events',
  Calculators = 'Calculators',
  AppInsights = 'App Insights',
  AliGroupInsurance = 'Ali group insurance',
  Reverse = 'Reverse'
}

interface ClaimsSettings {
  defaults: {
    country: Claims.Country;
  };
}

interface AuthSettings {
  domain: string;
}

export interface IAggregatorConfiguration extends AgpSharedAggregatorOptions {
  // flags to enable/disable features
  features: EnumDictionary<AggregatorFeatureFlag, boolean>;
  // settings
  settings: {
    claims: ClaimsSettings;
    auth: AuthSettings;
  };
}
